import {Reducer} from 'redux';
import {createFeatureCollection} from "../../utils/createFeatureCollection";
import {createFeatureFromViewNode} from "../../utils/createFeatureFromViewNode";
import {IApplicationState} from "../types";
import {dataLayer, dataLayerLineString, dataLayerPoint} from "./loadMapStyle";
import {List, Map} from 'immutable';
import {IFeature_CONO} from "../../types";
export interface IEntityViewNode {
    datelastchanged: string;
    description: string;
    fullUid: string;
    geoType: string;
    instruc: string;
    layername: string;
    layerid: number;
    membertype: string;
    name: string;
    notes: string;
    stAsgeojson: string;
    type: string;
    websiteurl: string;
}

export interface ILoadLayerDataPayload {
    layerType: string;
    data: IEntityViewNode[];
}

// NB: two concepts of layer id here - database id and layer 'type'
// layerid = 1,2,3
// type = 'APT_PT'

const reducer: Reducer<any> = (state, action) => {
    const { geoType, layerType } = action.payload;
    const data: IEntityViewNode[] = action.payload.data;
    const layersByType = createLayers(state, data, geoType);
    const layerState = {...state.layerState};
    let mapStyle = state.mapStyle;
    return {...state, mapStyle, layerState, layersByType}
};

function createLayers (state: IApplicationState['map'], data: IEntityViewNode[], geoType) {
    const layersByType: {[key:string]: any} = {...state.layersByType};
    const {mapStyle} = state;
    const keyPath = ['properties', 'fullUid'];
    const highlightedFeatures = getHighlightedFeatures(mapStyle);
    const features: Map<keyof IFeature_CONO, any> = highlightedFeatures.reduce(
        (result, item) =>
            result!.set(item?.getIn(keyPath), item),
        Map());
    const selectedIds = highlightedFeatures.map(
        (f): string =>
            f?.getIn(keyPath)
    ).toSet();
    data.forEach((node: IEntityViewNode) => {
        if (selectedIds.has(node.fullUid)) {
            Object.assign(node, {
                geojson: features.get(node.fullUid).get('geometry').toJS()
            });
        }
        const layerType = node.type;
        // const db_id = node.layerid;
        const layerExists = layersByType[layerType];
        const feature = createFeatureFromViewNode(node) as IFeature_CONO;
        // const layersIndex = layers.push(createFeature(node));
        if (layerExists) {
            layersByType[layerType].features.push(feature)
        } else {
            layersByType[layerType] = createFeatureCollection([feature]);
            // databaseLayerIds[layerType] = db_id;
            // layerIds.push(layerType);
        }
        layersByType[layerType].properties = {
            ...layersByType[layerType].properties,
            geoType
        };
    });
    return layersByType;
}

function getHighlightedFeatures (mapStyle: IApplicationState['map']['mapStyle']) {
    let features: List<Map<keyof IFeature_CONO, any>>;
    features = mapStyle
        .getIn(['sources', dataLayer.source, 'data', 'features']);
    features = features.concat(mapStyle
        .getIn(['sources', dataLayerPoint.source, 'data', 'features'])) as List<Map<keyof IFeature_CONO, any>>;
    features = features.concat(mapStyle
        .getIn(['sources', dataLayerLineString.source, 'data', 'features'])) as List<Map<keyof IFeature_CONO, any>>;
    return features;
}

export { reducer as loadLayerData };